import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'GuestPage' | 'OfferCard' | 'OnboardingTooltipProvider';

/**
 * Errors related to the Treats Rewards page
 */
export const Errors = createErrors<Page, Component>('TreatsRewards')({
    GuestPage: {
        GetTreatsPageGuest: {
            severity: 'MEDIUM',
            message: 'Failed to fetch Treats Rewards page content for guest',
        },
    },
    OfferCard: {
        ActivateOfferFailed: {
            severity: 'HIGH',
            message: 'Failed to activate an offer',
        },
    },
    OnboardingTooltipProvider: {
        SetOnboardingCompletedFailed: {
            severity: 'LOW',
            message: 'Failed to update loyalty onboarding completed status',
        },
    },
});
